var KIND_LABELS = { tour: 'Tour', guide: 'Guide', location: 'Location' };

function initHeaderSearch() {
  var container = document.querySelector('[data-autocomplete-url]');
  if (!container) return;

  var url = container.dataset.autocompleteUrl;
  var input = container.querySelector('.header-search__input');
  var results = container.querySelector('.header-search__results');
  var debounceTimer;

  function showResults(items) {
    results.innerHTML = '';
    if (!items.length) {
      results.classList.add('d-none');
      return;
    }

    items.forEach(function(item) {
      var li = document.createElement('li');
      li.className = 'header-search__result';

      var a = document.createElement('a');
      a.href = item.url;
      a.className = 'header-search__result-link';

      if (item.image_url) {
        var img = document.createElement('img');
        img.src = item.image_url;
        img.className = 'header-search__result-img';
        img.alt = '';
        a.appendChild(img);
      }

      var title = document.createElement('span');
      title.className = 'header-search__result-title';
      title.textContent = item.title;

      var badge = document.createElement('span');
      badge.className = 'header-search__result-kind header-search__result-kind--' + item.kind;
      badge.textContent = KIND_LABELS[item.kind] || item.kind;

      a.appendChild(title);
      a.appendChild(badge);
      li.appendChild(a);
      results.appendChild(li);
    });

    results.classList.remove('d-none');
  }

  function fetchResults(q) {
    fetch(url + '?q=' + encodeURIComponent(q))
      .then(function(res) { return res.json(); })
      .then(function(data) { showResults(data); })
      .catch(function() { results.classList.add('d-none'); });
  }

  input.addEventListener('input', function() {
    var q = input.value.trim();
    clearTimeout(debounceTimer);

    if (q.length < 2) {
      results.classList.add('d-none');
      return;
    }

    debounceTimer = setTimeout(function() { fetchResults(q); }, 250);
  });

  document.addEventListener('click', function(e) {
    if (!container.contains(e.target)) {
      results.classList.add('d-none');
    }
  });

  input.addEventListener('focus', function() {
    if (input.value.trim().length >= 2) {
      results.classList.remove('d-none');
    }
  });
}

document.addEventListener('DOMContentLoaded', initHeaderSearch);
